export type Lang = 'fr' | 'en' | 'nl';

export const translations: Record<Lang, Record<string, string>> = {
  fr: {
    // ── Common ──
    'common.cancel': 'Annuler',
    'common.save': 'Enregistrer',
    'common.close': 'Fermer',
    'common.loading': 'Chargement...',
    'common.search': 'Chercher',
    'common.free': 'Gratuit',
    'common.error': 'Erreur',
    'common.all': 'Tout',
    'common.none': 'Aucun',
    'common.add': 'Ajouter',
    'common.delete': 'Supprimer',
    'common.name': 'Nom',
    'common.type': 'Type',
    'common.status': 'Statut',
    'common.actions': 'Actions',
    'common.on': 'ON',
    'common.off': 'OFF',
    'common.ok': 'OK',
    'common.yes': 'Oui',
    'common.no': 'Non',

    // ── Header ──
    'header.subtitle': 'Reggae · Dub · Dancehall — Belgique',
    'header.active': 'Veille Active',

    // ── Auth ──
    'auth.login': 'Connexion admin',
    'auth.logout': 'Déconnexion',
    'auth.password': 'Mot de passe',
    'auth.invalid_password': 'Mot de passe incorrect',

    // ── Tabs ──
    'tabs.agenda': 'Agenda',
    'tabs.social': 'Veille Sociale',
    'tabs.discovery': 'Découverte',
    'tabs.map': 'Carte',
    'tabs.soundsystems': 'Sound Systems',
    'tabs.artists': 'Artistes',
    'tabs.validation': 'Validation',
    'tabs.sources': 'Sources',
    'tabs.radar': 'Boom Zoom City',

    // ── City Radar ──
    'radar.title': 'Boom Zoom City',
    'radar.select_city': 'Sélectionner une ville',
    'radar.scanning': 'Scan en cours...',
    'radar.scan_now': 'Scanner',
    'radar.events_found': 'événements trouvés',
    'radar.no_events': 'Aucun événement détecté. Lancez un scan.',
    'radar.sources': 'Sources',
    'radar.artists': 'Artistes détectés',
    'radar.last_scan': 'Dernier scan',
    'radar.explainer': "Boom Zoom City met en lumière la scène dub & reggae d'une ville mise à l'honneur, au-delà de la Belgique — les événements y sont découverts comme dans l'agenda principal.",
    'radar.wip': "En cours de développement : la couverture et la précision sont encore en réglage.",
    'radar.radius': 'Rayon',
    'radar.never_scanned': 'Jamais scanné',
    'radar.wip_label': 'Travaux en cours',
    'radar.wip_message': 'La fonction Boom Zoom City est en cours de construction. Restez à l\'écoute — elle arrive bientôt.',
    'radar.add_city': 'Ajouter une ville',
    'radar.city_name': 'Nom de la ville',
    'radar.country': 'Pays (code ISO, ex. FR)',
    'radar.language': 'Langue',
    'radar.keywords': 'Mots-clés locaux (séparés par des virgules)',
    'radar.create': 'Créer + découvrir les sources',
    'radar.creating': 'Création...',
    'radar.create_error': 'Échec de la création',
    'radar.ig_focus': 'Focus découverte IG',
    'radar.ig_focus_hint': 'Une seule ville à la fois : le scan d\'opportunité Instagram consacre sa recherche du cycle à cette ville (budget anti-CIB inchangé).',
    'radar.active': 'Active',
    'radar.next_scan_in': 'Prochain scan Boom Zoom (toutes villes) dans',
    'radar.no_active_city': 'Aucune ville active pour le moment. Revenez bientôt.',

    // ── Agenda ──
    'agenda.upcoming_events': 'Events à venir',
    'agenda.total_events': 'Total événements',
    'agenda.venues_followed': 'Venues suivies',
    'agenda.active_sources': 'Sources actives',
    'agenda.upcoming': 'A venir',
    'agenda.past': 'Passés',
    'agenda.all': 'Tous',
    'agenda.search_placeholder': 'Chercher événement, artiste, ville...',
    'agenda.add': '+ Ajouter',
    'agenda.flyer_ocr': 'Flyer OCR',
    'agenda.upcoming_title': 'Prochains Événements',
    'agenda.past_title': 'Événements Passés',
    'agenda.all_title': 'Tous les Événements',
    'agenda.scan_now': 'Scanner Maintenant',
    'agenda.scanning': 'Scan en cours...',
    'agenda.no_events': 'Aucun événement trouvé.',
    'agenda.launch_scan': 'Lancez un scan ou ajoutez des événements manuellement.',
    'agenda.results': 'résultats',
    'agenda.city_filter_warning': 'Filtre par ville approximatif — un événement peut manquer si sa localisation n\'a pas pu être détectée.',
    'edit_event.title': 'Modifier l\'événement',
    'edit_event.edit': 'Éditer',
    'edit_event.save': 'Enregistrer',
    'edit_event.status_label': 'Statut',
    'edit_event.free': 'Gratuit',
    'edit_event.missing': 'Titre et date obligatoires.',
    'status.validated': 'Validé',
    'status.pending': 'En attente',
    'status.rejected': 'Rejeté',

    // ── Map ──
    'map.title': 'Carte des Événements',
    'map.geolocated': 'événements géolocalisés sur',
    'map.today': "Aujourd'hui",
    'map.pulsing': '(pulsant)',
    'map.this_week': 'Cette semaine',
    'map.this_month': 'Ce mois',
    'map.later': 'Plus tard',
    'map.today_excl': "Aujourd'hui !",
    'map.tomorrow': 'Demain !',
    'map.in_days': 'Dans {n} jours',
    'map.in_weeks': 'Dans {n} semaines',
    'map.in_months': 'Dans {n} mois',
    'map.by_city': 'Par Ville',
    'map.all_cities': 'Toutes',

    // ── Events ──
    'events.lineup': 'Line-up',
    'events.venue_tbc': 'Lieu à confirmer',
    'events.price_unknown': 'Prix inconnu',
    'events.late': 'LATE',
    'events.details': 'Détails',
    'events.source': 'Source',
    'events.more': '+ {n} de plus',

    // ── Sources ──
    'sources.title': 'Sources & Découverte',
    'sources.active_tab': 'Sources actives',
    'sources.probation_tab': 'En probation',
    'sources.logs_tab': 'Historique scans',
    'sources.add_source': '+ Ajouter une source',
    'sources.active_label': 'actives',
    'sources.inactive_label': 'inactives',
    'sources.probation_label': 'en probation',
    'sources.inactive_section': 'Sources inactives',
    'sources.other_sources': 'Autres sources',
    'sources.all_toggle': 'Toutes',
    'sources.scan': 'Scan',
    'sources.last_scan': 'Dernier scan',
    'sources.never': 'Jamais',
    'sources.filter': 'Filtrer:',
    'sources.probation_desc': 'Sources auto-découvertes via @mentions. Après 4 scans hebdomadaires sans événements pertinents, elles sont exclues automatiquement.',
    'sources.no_probation': 'Aucune source en probation',
    'sources.logs_title': 'Historique des scans (50 derniers)',
    'sources.date': 'Date',
    'sources.events_found': 'Événements',
    'sources.duration': 'Durée',
    'sources.source_name': 'Source',
    'sources.url': 'URL',
    'sources.activating': 'Activation en cours...',
    'sources.deactivating': 'Désactivation en cours...',
    'sources.activated': '{n} sources activées',
    'sources.deactivated': '{n} sources désactivées',
    'sources.delete_confirm': 'Supprimer cette source ?',
    'sources.scan_running': 'Scan en cours...',
    'sources.scan_done': 'Scan terminé',
    'sources.scan_error': 'Erreur de scan',

    // ── Social ──
    'social.title': 'Veille Sociale',
    'social.no_posts': 'Aucun post social trouvé.',
    'social.launch_scan': 'Lancez un scan pour récupérer les posts des sources actives.',
    'social.view_post': 'Voir le post',

    // ── Discovery ──
    'discovery.title': 'Découverte',
    'discovery.events_discovered': 'Événements découverts',
    'discovery.scan_logs': 'Logs de scan',
    'discovery.refresh': 'Rafraichir',
    'discovery.events_label': 'Événements',
    'discovery.scans_ok': 'Scans OK',
    'discovery.errors': 'Erreurs',
    'discovery.detected_by_scan': 'Détectés par scan',
    'discovery.no_events': 'Aucun événement découvert.',
    'discovery.no_scans': 'Aucun scan effectué.',

    // ── Validation ──
    'validation.title': 'File de Validation',
    'validation.validate_all': 'Tout valider',
    'validation.no_pending': 'Aucun événement en attente de validation.',
    'validation.suspected_dupes': 'Doublons potentiels',
    'validation.similarity': 'similarité',
    'validation.validate': 'Valider',
    'validation.reject': 'Rejeter',
    'validation.edit': 'Éditer',
    'validation.artists': 'Artistes',
    'validation.venue_known': 'Venue connue',
    'validation.venue_unknown': 'Venue inconnue',
    'validation.keep_first': 'Garder 1er, rejeter 2e',
    'validation.keep_second': 'Garder 2e, rejeter 1er',
    'validation.ignore': 'Ignorer',
    'validation.pairs': '{n} paire(s) — même date, même ville, titres similaires',
    'validation.flyer_matches': 'Correspondances de flyers (pHash)',
    'validation.merge_keep_left': 'Fusionner (garder le 1er)',
    'validation.merge_keep_right': 'Fusionner (garder le 2e)',
    'validation.close': 'Fermer',
    'validation.not_duplicate': 'Pas un doublon',
    'validation.expand': 'Déplier',
    'validation.collapse': 'Replier',
    'validation.view_source': 'Source',
    'validation.view_pending': 'En attente',
    'validation.view_rejected': 'Rejetés',
    'validation.rejected_title': 'Événements rejetés',
    'validation.rejected_hint': 'Analyser les raisons pour corriger les bugs systémiques',
    'validation.no_rejected': 'Aucun événement rejeté',
    'validation.permanent_delete': 'Supprimer définitivement',
    'validation.confirm_permanent_delete': 'Supprimer définitivement cet événement ? Cette action est irréversible.',

    // ── Artists ──
    'artists.title': 'Artistes & Sound Systems',
    'artists.search': 'Chercher un artiste ou sound system...',
    'artists.artists': 'artistes',
    'artists.sound_systems': 'sound systems',
    'artists.genres': 'Genres',
    'artists.country': 'Pays',
    'artists.links': 'Liens',
    'artists.artist': 'Artiste',
    'artists.next_event_in': 'Prochain event dans',
    'artists.events_count': 'Événements',
    'artists.no_events': 'Aucun événement lié',

    // ── Sound Systems ──
    'soundsystems.title': 'Sound Systems',
    'soundsystems.followed': 'sound systems suivis',
    'soundsystems.search': 'Chercher un sound system...',
    'soundsystems.no_found': 'Aucun sound system trouvé.',
    'soundsystems.events_count': 'Événements',
    'soundsystems.no_events': 'Aucun événement détecté',
    'soundsystems.website': 'Site Web',

    // ── Sidebar ──
    'sidebar.this_week': 'Cette Semaine',
    'sidebar.no_events': 'Aucun event cette semaine',
    'sidebar.by_city': 'Par Ville',
    'sidebar.all_cities': 'Toutes',
    'sidebar.view_on_map': 'Voir {n} sur la carte',
    'sidebar.by_month': 'Par Mois',
    'sidebar.active_sources': 'Sources Actives',
    'sidebar.venues': 'lieux',

    // ── Add Event Modal ──
    'add_event.title': 'Ajouter un Événement',
    'add_event.event_name': "Nom de l'événement",
    'add_event.title_label': 'Titre',
    'add_event.date_label': 'Date',
    'add_event.price_label': 'Prix',
    'add_event.price_placeholder': '10€ / Gratuit',
    'add_event.venue_label': 'Lieu',
    'add_event.venue_placeholder': 'Nom du lieu',
    'add_event.city_label': 'Ville',
    'add_event.city_placeholder': 'Bruxelles',
    'add_event.genres_label': 'Genres',
    'add_event.description_label': 'Description',
    'add_event.description_placeholder': "Description de l'événement",
    'add_event.source_label': 'Lien source',
    'add_event.create': "Créer l'événement",
    'add_event.saving': 'Enregistrement...',

    // ── Flyer OCR Modal ──
    'flyer.scanner': 'FLYER SCANNER',
    'flyer.powered': 'VISION AI POWERED',
    'flyer.instructions': "Prenez en photo un poster, uploadez un flyer ou collez depuis le presse-papier (Ctrl+V)",
    'flyer.drop_here': 'Glisser un flyer ici',
    'flyer.click_upload': 'ou cliquer pour choisir un fichier',
    'flyer.paste': 'Ctrl+V pour coller depuis le presse-papier',
    'flyer.upload': 'Upload...',
    'flyer.prescan': 'Pre-scan...',
    'flyer.vision': 'Vision AI...',
    'flyer.finalizing': 'Finalisation...',
    'flyer.minimize': 'Minimiser',
    'flyer.validate': 'Valider',
    'flyer.saving': 'Enregistrement...',
    'flyer.start': 'Debut',
    'flyer.end': 'Fin',
    'flyer.artists': 'Artistes',
    'flyer.missing_date': "Date obligatoire — l'OCR ne l'a pas trouvée sur le flyer. Renseigne-la pour valider.",
    'flyer.missing_title': 'Titre obligatoire. Renseigne-le pour valider.',
    'flyer.missing_title_date': "Titre et date obligatoires — l'OCR ne les a pas trouvés sur le flyer.",
    'flyer.session_expired': 'Session expirée — reconnecte-toi puis réessaie.',
    'flyer.save_failed': "Échec de l'enregistrement. Réessaie.",

    // ── OCR Mode ──
    'ocr.label': 'OCR',
    'ocr.tesseract': 'Tesseract seul',
    'ocr.vision_light': 'Vision Light',
    'ocr.vision_medium': 'Vision Medium',
    'ocr.vision_full': 'Vision Full',

    // ── IG Session ──
    'ig.missing': 'Session Instagram absente — les comptes Instagram ne peuvent pas être scrapés.',
    'ig.expired': 'Session Instagram expirée.',
    'ig.invalid': 'Session Instagram invalide.',
    'ig.logging_in': 'Une fenêtre Chrome s\'est ouverte — connectez-vous à Instagram.',
    'ig.waiting': 'En attente de connexion…',
    'ig.reconnect': 'Reconnecter Instagram',

    // ── Support ──
    'support.button': 'Soutenir le Riddim Radar',
    'support.button_short': 'Support Riddim Radar',
    'support.title': 'Comment soutenir le Riddim Radar',
    'support.intro': 'Merci de vouloir nous soutenir et nous sommes reconnaissants que le Riddim Radar vous plaise. Cet outil est gratuit et concu avec du code IA comme un cadeau a la communaute reggae et dub.',
    'support.sources_message': "Il repose sur le travail infatigable de nos sources et n'est qu'un agregateur du travail de vraies personnes qui creent des evenements, designent des flyers, construisent des sound systems, gerent des collectifs et consacrent leurs reseaux sociaux a diffuser les evenements et la vibe de Jah.",
    'support.action_intro': "Voici la liste des sources que nous agregeons sur Riddim Radar. Allez sur leurs reseaux sociaux et suivez-les pour augmenter leur audience. Donnez-leur des likes et partagez les evenements et les stories. Suivez les artistes et achetez leur musique.",
    'support.action_flyer': "Allez dans votre bar prefere et organisez une soiree dub gratuite (n'oubliez pas d'uploader le flyer dans l'OCR pour qu'on le liste ici).",
    'support.future': "Nous avons quelques idees pour l'avenir ou nous pourrions demander des dons pour des projets specifiques, mais pour l'instant la meilleure facon de nous soutenir est de soutenir nos sources. Cet outil n'est qu'une maniere de les remercier pour leur incroyable amour et devotion.",
    'support.thanks': 'Merci',
    'support.bless': 'Jah bless',
    'support.contact': 'Si vous souhaitez nous contacter :',
    'footer.tagline': 'projet personnel non commercial',
    'footer.legal': 'Mentions légales',
    'footer.privacy': 'Politique de confidentialité',
    'footer.contact': 'Contact',
    'support.our_sources': 'Nos sources',
    'support.artists_link': 'Voir les artistes',
    'support.follow': 'Suivre',

    // ── Date ──
    'date.days': 'dimanche,lundi,mardi,mercredi,jeudi,vendredi,samedi',
    'date.months': 'janvier,février,mars,avril,mai,juin,juillet,août,septembre,octobre,novembre,décembre',
    // Short names for date chips. Explicit per-locale table — naive slice(0,3)
    // collapses juin↔juillet to the same "JUI" which breaks every Jun/Jul event.
    'date.months_short': 'janv.,févr.,mars,avril,mai,juin,juil.,août,sept.,oct.,nov.,déc.',
  },

  en: {
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.search': 'Search',
    'common.free': 'Free',
    'common.error': 'Error',
    'common.all': 'All',
    'common.none': 'None',
    'common.add': 'Add',
    'common.delete': 'Delete',
    'common.name': 'Name',
    'common.type': 'Type',
    'common.status': 'Status',
    'common.actions': 'Actions',
    'common.on': 'ON',
    'common.off': 'OFF',
    'common.ok': 'OK',
    'common.yes': 'Yes',
    'common.no': 'No',

    'header.subtitle': 'Reggae · Dub · Dancehall — Belgium',
    'header.active': 'Active Monitoring',

    'auth.login': 'Admin login',
    'auth.logout': 'Logout',
    'auth.password': 'Password',
    'auth.invalid_password': 'Invalid password',

    'tabs.agenda': 'Agenda',
    'tabs.social': 'Social Watch',
    'tabs.discovery': 'Discovery',
    'tabs.map': 'Map',
    'tabs.soundsystems': 'Sound Systems',
    'tabs.artists': 'Artists',
    'tabs.validation': 'Validation',
    'tabs.sources': 'Sources',
    'tabs.radar': 'Boom Zoom City',

    'radar.title': 'Boom Zoom City',
    'radar.select_city': 'Select a city',
    'radar.scanning': 'Scanning...',
    'radar.scan_now': 'Scan',
    'radar.events_found': 'events found',
    'radar.no_events': 'No events detected. Run a scan.',
    'radar.sources': 'Sources',
    'radar.artists': 'Artists detected',
    'radar.last_scan': 'Last scan',
    'radar.explainer': 'Boom Zoom City spotlights the dub & reggae scene of one featured city beyond Belgium — events are discovered the same way as in the main agenda.',
    'radar.wip': 'Work in progress: coverage and accuracy are still being tuned.',
    'radar.radius': 'Radius',
    'radar.never_scanned': 'Never scanned',
    'radar.wip_label': 'Work in progress',
    'radar.wip_message': 'Boom Zoom City is under construction. Stay tuned — it\'s coming soon.',
    'radar.add_city': 'Add a city',
    'radar.city_name': 'City name',
    'radar.country': 'Country (ISO code, e.g. FR)',
    'radar.language': 'Language',
    'radar.keywords': 'Local keywords (comma-separated)',
    'radar.create': 'Create + discover sources',
    'radar.creating': 'Creating...',
    'radar.create_error': 'Creation failed',
    'radar.ig_focus': 'IG discovery focus',
    'radar.ig_focus_hint': 'One city at a time: the Instagram opportunity scan spends its per-cycle search on this city (anti-CIB budget unchanged).',
    'radar.active': 'Active',
    'radar.next_scan_in': 'Next Boom Zoom scan (all cities) in',
    'radar.no_active_city': 'No active city right now. Check back soon.',

    'agenda.upcoming_events': 'Upcoming events',
    'agenda.total_events': 'Total events',
    'agenda.venues_followed': 'Venues followed',
    'agenda.active_sources': 'Active sources',
    'agenda.upcoming': 'Upcoming',
    'agenda.past': 'Past',
    'agenda.all': 'All',
    'agenda.search_placeholder': 'Search event, artist, city...',
    'agenda.add': '+ Add',
    'agenda.flyer_ocr': 'Flyer OCR',
    'agenda.upcoming_title': 'Upcoming Events',
    'agenda.past_title': 'Past Events',
    'agenda.all_title': 'All Events',
    'agenda.scan_now': 'Scan Now',
    'agenda.scanning': 'Scanning...',
    'agenda.no_events': 'No events found.',
    'agenda.launch_scan': 'Run a scan or add events manually.',
    'agenda.results': 'results',
    'agenda.city_filter_warning': 'City filter is best-effort — an event may be missing if its location couldn\'t be detected.',
    'edit_event.title': 'Edit event',
    'edit_event.edit': 'Edit',
    'edit_event.save': 'Save',
    'edit_event.status_label': 'Status',
    'edit_event.free': 'Free',
    'edit_event.missing': 'Title and date are required.',
    'status.validated': 'Validated',
    'status.pending': 'Pending',
    'status.rejected': 'Rejected',

    'map.title': 'Event Map',
    'map.geolocated': 'geolocated events out of',
    'map.today': 'Today',
    'map.pulsing': '(pulsing)',
    'map.this_week': 'This week',
    'map.this_month': 'This month',
    'map.later': 'Later',
    'map.today_excl': 'Today!',
    'map.tomorrow': 'Tomorrow!',
    'map.in_days': 'In {n} days',
    'map.in_weeks': 'In {n} weeks',
    'map.in_months': 'In {n} months',
    'map.by_city': 'By City',
    'map.all_cities': 'All',

    'events.lineup': 'Line-up',
    'events.venue_tbc': 'Venue TBC',
    'events.price_unknown': 'Price unknown',
    'events.late': 'LATE',
    'events.details': 'Details',
    'events.source': 'Source',
    'events.more': '+ {n} more',

    'sources.title': 'Sources & Discovery',
    'sources.active_tab': 'Active sources',
    'sources.probation_tab': 'On probation',
    'sources.logs_tab': 'Scan history',
    'sources.add_source': '+ Add source',
    'sources.active_label': 'active',
    'sources.inactive_label': 'inactive',
    'sources.probation_label': 'on probation',
    'sources.inactive_section': 'Inactive sources',
    'sources.other_sources': 'Other sources',
    'sources.all_toggle': 'All',
    'sources.scan': 'Scan',
    'sources.last_scan': 'Last scan',
    'sources.never': 'Never',
    'sources.filter': 'Filter:',
    'sources.probation_desc': 'Auto-discovered sources via @mentions. After 4 weekly scans without relevant events, they are automatically excluded.',
    'sources.no_probation': 'No sources on probation',
    'sources.logs_title': 'Scan history (last 50)',
    'sources.date': 'Date',
    'sources.events_found': 'Events',
    'sources.duration': 'Duration',
    'sources.source_name': 'Source',
    'sources.url': 'URL',
    'sources.activating': 'Activating...',
    'sources.deactivating': 'Deactivating...',
    'sources.activated': '{n} sources activated',
    'sources.deactivated': '{n} sources deactivated',
    'sources.delete_confirm': 'Delete this source?',
    'sources.scan_running': 'Scanning...',
    'sources.scan_done': 'Scan complete',
    'sources.scan_error': 'Scan error',

    'social.title': 'Social Watch',
    'social.no_posts': 'No social posts found.',
    'social.launch_scan': 'Run a scan to fetch posts from active sources.',
    'social.view_post': 'View post',

    'discovery.title': 'Discovery',
    'discovery.events_discovered': 'Events discovered',
    'discovery.scan_logs': 'Scan logs',
    'discovery.refresh': 'Refresh',
    'discovery.events_label': 'Events',
    'discovery.scans_ok': 'Scans OK',
    'discovery.errors': 'Errors',
    'discovery.detected_by_scan': 'Detected by scan',
    'discovery.no_events': 'No events discovered.',
    'discovery.no_scans': 'No scans performed.',

    'validation.title': 'Validation Queue',
    'validation.validate_all': 'Validate all',
    'validation.no_pending': 'No events pending validation.',
    'validation.suspected_dupes': 'Suspected duplicates',
    'validation.similarity': 'similarity',
    'validation.validate': 'Validate',
    'validation.reject': 'Reject',
    'validation.edit': 'Edit',
    'validation.artists': 'Artists',
    'validation.venue_known': 'Known venue',
    'validation.venue_unknown': 'Unknown venue',
    'validation.keep_first': 'Keep 1st, reject 2nd',
    'validation.keep_second': 'Keep 2nd, reject 1st',
    'validation.ignore': 'Ignore',
    'validation.pairs': '{n} pair(s) — same date, same city, similar titles',
    'validation.flyer_matches': 'Flyer matches (pHash)',
    'validation.merge_keep_left': 'Merge (keep 1st)',
    'validation.merge_keep_right': 'Merge (keep 2nd)',
    'validation.close': 'Close',
    'validation.not_duplicate': 'Not a duplicate',
    'validation.expand': 'Expand',
    'validation.collapse': 'Collapse',
    'validation.view_source': 'Source',
    'validation.view_pending': 'Pending',
    'validation.view_rejected': 'Rejected',
    'validation.rejected_title': 'Rejected events',
    'validation.rejected_hint': 'Analyse reasons to fix systematic bugs',
    'validation.no_rejected': 'No rejected events',
    'validation.permanent_delete': 'Permanently delete',
    'validation.confirm_permanent_delete': 'Permanently delete this event? This cannot be undone.',

    'artists.title': 'Artists & Sound Systems',
    'artists.search': 'Search artist or sound system...',
    'artists.artists': 'artists',
    'artists.sound_systems': 'sound systems',
    'artists.genres': 'Genres',
    'artists.country': 'Country',
    'artists.links': 'Links',
    'artists.artist': 'Artist',
    'artists.next_event_in': 'Next event in',
    'artists.events_count': 'Events',
    'artists.no_events': 'No linked events',

    'soundsystems.title': 'Sound Systems',
    'soundsystems.followed': 'sound systems followed',
    'soundsystems.search': 'Search sound system...',
    'soundsystems.no_found': 'No sound systems found.',
    'soundsystems.events_count': 'Events',
    'soundsystems.no_events': 'No events detected',
    'soundsystems.website': 'Website',

    'sidebar.this_week': 'This Week',
    'sidebar.no_events': 'No events this week',
    'sidebar.by_city': 'By City',
    'sidebar.all_cities': 'All',
    'sidebar.view_on_map': 'View {n} on map',
    'sidebar.by_month': 'By Month',
    'sidebar.active_sources': 'Active Sources',
    'sidebar.venues': 'venues',

    'add_event.title': 'Add Event',
    'add_event.event_name': 'Event name',
    'add_event.title_label': 'Title',
    'add_event.date_label': 'Date',
    'add_event.price_label': 'Price',
    'add_event.price_placeholder': '10€ / Free',
    'add_event.venue_label': 'Venue',
    'add_event.venue_placeholder': 'Venue name',
    'add_event.city_label': 'City',
    'add_event.city_placeholder': 'Brussels',
    'add_event.genres_label': 'Genres',
    'add_event.description_label': 'Description',
    'add_event.description_placeholder': 'Event description',
    'add_event.source_label': 'Source link',
    'add_event.create': 'Create event',
    'add_event.saving': 'Saving...',

    'flyer.scanner': 'FLYER SCANNER',
    'flyer.powered': 'VISION AI POWERED',
    'flyer.instructions': 'Take a photo of a poster, upload a flyer, or paste from clipboard (Ctrl+V)',
    'flyer.drop_here': 'Drop a flyer here',
    'flyer.click_upload': 'or click to choose a file',
    'flyer.paste': 'Ctrl+V to paste from clipboard',
    'flyer.upload': 'Upload...',
    'flyer.prescan': 'Pre-scan...',
    'flyer.vision': 'Vision AI...',
    'flyer.finalizing': 'Finalizing...',
    'flyer.minimize': 'Minimize',
    'flyer.validate': 'Validate',
    'flyer.saving': 'Saving...',
    'flyer.start': 'Start',
    'flyer.end': 'End',
    'flyer.artists': 'Artists',
    'flyer.missing_date': "Date required — OCR didn't find it on the flyer. Fill it in to save.",
    'flyer.missing_title': 'Title required. Fill it in to save.',
    'flyer.missing_title_date': "Title and date required — OCR didn't find them on the flyer.",
    'flyer.session_expired': 'Session expired — log in again, then retry.',
    'flyer.save_failed': 'Save failed. Please retry.',

    'ocr.label': 'OCR',
    'ocr.tesseract': 'Tesseract only',
    'ocr.vision_light': 'Vision Light',
    'ocr.vision_medium': 'Vision Medium',
    'ocr.vision_full': 'Vision Full',

    'ig.missing': 'Instagram session missing — Instagram accounts cannot be scraped.',
    'ig.expired': 'Instagram session expired.',
    'ig.invalid': 'Instagram session invalid.',
    'ig.logging_in': 'A Chrome window has opened — log in to Instagram.',
    'ig.waiting': 'Waiting for connection…',
    'ig.reconnect': 'Reconnect Instagram',

    // ── Support ──
    'support.button': 'How to Support the Riddim Radar',
    'support.button_short': 'Support Riddim Radar',
    'support.title': 'How to Support the Riddim Radar',
    'support.intro': 'Thank you for willing to support us and we are grateful you like the Riddim Radar. This tool is free and designed with AI code as a gift to the reggae dub community.',
    'support.sources_message': 'It relies on the tireless work of our sources and it is merely an aggregator of the work of real people who create events, design flyers, build sound systems, run collectives, and dedicate social network accounts to spread the events and Jah vibe.',
    'support.action_intro': 'Here is a list of the sources we aggregate on Riddim Radar. Go on their social network and follow them so they increase their followers. Give them likes, and share the events and the stories. Follow the artists and buy their music.',
    'support.action_flyer': "Go to your favourite bar and organise a free dub night (don't forget to upload the flyer to the flyer OCR so we list it here).",
    'support.future': 'We have some ideas for the future where we might ask for some donation for specific projects, but for now the best way to support us is to support our sources. This tool is only a way to thank them for their incredible love and dedication.',
    'support.thanks': 'Thank you',
    'support.bless': 'Jah bless',
    'support.contact': 'If you want to contact us:',
    'footer.tagline': 'non-commercial personal project',
    'footer.legal': 'Legal notice',
    'footer.privacy': 'Privacy policy',
    'footer.contact': 'Contact',
    'support.our_sources': 'Our sources',
    'support.artists_link': 'See artists',
    'support.follow': 'Follow',

    'date.days': 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday',
    'date.months': 'January,February,March,April,May,June,July,August,September,October,November,December',
    'date.months_short': 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
  },

  nl: {
    'common.cancel': 'Annuleren',
    'common.save': 'Opslaan',
    'common.close': 'Sluiten',
    'common.loading': 'Laden...',
    'common.search': 'Zoeken',
    'common.free': 'Gratis',
    'common.error': 'Fout',
    'common.all': 'Alles',
    'common.none': 'Geen',
    'common.add': 'Toevoegen',
    'common.delete': 'Verwijderen',
    'common.name': 'Naam',
    'common.type': 'Type',
    'common.status': 'Status',
    'common.actions': 'Acties',
    'common.on': 'AAN',
    'common.off': 'UIT',
    'common.ok': 'OK',
    'common.yes': 'Ja',
    'common.no': 'Nee',

    'header.subtitle': 'Reggae · Dub · Dancehall — België',
    'header.active': 'Actieve Monitoring',

    'auth.login': 'Admin login',
    'auth.logout': 'Afmelden',
    'auth.password': 'Wachtwoord',
    'auth.invalid_password': 'Ongeldig wachtwoord',

    'tabs.agenda': 'Agenda',
    'tabs.social': 'Sociale Radar',
    'tabs.discovery': 'Ontdekking',
    'tabs.map': 'Kaart',
    'tabs.soundsystems': 'Sound Systems',
    'tabs.artists': 'Artiesten',
    'tabs.validation': 'Validatie',
    'tabs.sources': 'Bronnen',
    'tabs.radar': 'Boom Zoom City',

    'radar.title': 'Boom Zoom City',
    'radar.select_city': 'Selecteer een stad',
    'radar.scanning': 'Scannen...',
    'radar.scan_now': 'Scannen',
    'radar.events_found': 'evenementen gevonden',
    'radar.no_events': 'Geen evenementen gedetecteerd. Start een scan.',
    'radar.sources': 'Bronnen',
    'radar.artists': 'Gedetecteerde artiesten',
    'radar.last_scan': 'Laatste scan',
    'radar.explainer': 'Boom Zoom City belicht de dub- & reggaescene van één uitgelichte stad buiten België — evenementen worden op dezelfde manier gevonden als in de hoofdagenda.',
    'radar.wip': 'Werk in uitvoering: dekking en nauwkeurigheid worden nog verfijnd.',
    'radar.radius': 'Straal',
    'radar.never_scanned': 'Nooit gescand',
    'radar.wip_label': 'In ontwikkeling',
    'radar.wip_message': 'Boom Zoom City is in aanbouw. Blijf op de hoogte — het komt binnenkort.',
    'radar.add_city': 'Stad toevoegen',
    'radar.city_name': 'Stadsnaam',
    'radar.country': 'Land (ISO-code, bv. FR)',
    'radar.language': 'Taal',
    'radar.keywords': 'Lokale zoektermen (komma-gescheiden)',
    'radar.create': 'Aanmaken + bronnen ontdekken',
    'radar.creating': 'Aanmaken...',
    'radar.create_error': 'Aanmaken mislukt',
    'radar.ig_focus': 'IG-ontdekkingsfocus',
    'radar.ig_focus_hint': 'Eén stad tegelijk: de Instagram-opportuniteitsscan besteedt zijn zoekopdracht per cyclus aan deze stad (anti-CIB-budget ongewijzigd).',
    'radar.active': 'Actief',
    'radar.next_scan_in': 'Volgende Boom Zoom-scan (alle steden) over',
    'radar.no_active_city': 'Geen actieve stad op dit moment. Kom binnenkort terug.',

    'agenda.upcoming_events': 'Komende events',
    'agenda.total_events': 'Totaal events',
    'agenda.venues_followed': 'Gevolgde venues',
    'agenda.active_sources': 'Actieve bronnen',
    'agenda.upcoming': 'Komend',
    'agenda.past': 'Voorbij',
    'agenda.all': 'Alle',
    'agenda.search_placeholder': 'Zoek evenement, artiest, stad...',
    'agenda.add': '+ Toevoegen',
    'agenda.flyer_ocr': 'Flyer OCR',
    'agenda.upcoming_title': 'Komende Evenementen',
    'agenda.past_title': 'Voorbije Evenementen',
    'agenda.all_title': 'Alle Evenementen',
    'agenda.scan_now': 'Nu Scannen',
    'agenda.scanning': 'Scannen...',
    'agenda.no_events': 'Geen evenementen gevonden.',
    'agenda.launch_scan': 'Start een scan of voeg evenementen handmatig toe.',
    'agenda.results': 'resultaten',
    'agenda.city_filter_warning': 'Stadsfilter bij benadering — een evenement kan ontbreken als de locatie niet kon worden bepaald.',
    'edit_event.title': 'Evenement bewerken',
    'edit_event.edit': 'Bewerken',
    'edit_event.save': 'Opslaan',
    'edit_event.status_label': 'Status',
    'edit_event.free': 'Gratis',
    'edit_event.missing': 'Titel en datum zijn verplicht.',
    'status.validated': 'Gevalideerd',
    'status.pending': 'In afwachting',
    'status.rejected': 'Afgewezen',

    'map.title': 'Evenementen Kaart',
    'map.geolocated': 'gelokaliseerde evenementen van',
    'map.today': 'Vandaag',
    'map.pulsing': '(pulserend)',
    'map.this_week': 'Deze week',
    'map.this_month': 'Deze maand',
    'map.later': 'Later',
    'map.today_excl': 'Vandaag!',
    'map.tomorrow': 'Morgen!',
    'map.in_days': 'Over {n} dagen',
    'map.in_weeks': 'Over {n} weken',
    'map.in_months': 'Over {n} maanden',
    'map.by_city': 'Per Stad',
    'map.all_cities': 'Alle',

    'events.lineup': 'Line-up',
    'events.venue_tbc': 'Locatie te bevestigen',
    'events.price_unknown': 'Prijs onbekend',
    'events.late': 'LAAT',
    'events.details': 'Details',
    'events.source': 'Bron',
    'events.more': '+ {n} meer',

    'sources.title': 'Bronnen & Ontdekking',
    'sources.active_tab': 'Actieve bronnen',
    'sources.probation_tab': 'Op proef',
    'sources.logs_tab': 'Scangeschiedenis',
    'sources.add_source': '+ Bron toevoegen',
    'sources.active_label': 'actief',
    'sources.inactive_label': 'inactief',
    'sources.probation_label': 'op proef',
    'sources.inactive_section': 'Inactieve bronnen',
    'sources.other_sources': 'Andere bronnen',
    'sources.all_toggle': 'Alle',
    'sources.scan': 'Scan',
    'sources.last_scan': 'Laatste scan',
    'sources.never': 'Nooit',
    'sources.filter': 'Filter:',
    'sources.probation_desc': 'Automatisch ontdekte bronnen via @vermeldingen. Na 4 wekelijkse scans zonder relevante evenementen worden ze automatisch uitgesloten.',
    'sources.no_probation': 'Geen bronnen op proef',
    'sources.logs_title': 'Scangeschiedenis (laatste 50)',
    'sources.date': 'Datum',
    'sources.events_found': 'Evenementen',
    'sources.duration': 'Duur',
    'sources.source_name': 'Bron',
    'sources.url': 'URL',
    'sources.activating': 'Activeren...',
    'sources.deactivating': 'Deactiveren...',
    'sources.activated': '{n} bronnen geactiveerd',
    'sources.deactivated': '{n} bronnen gedeactiveerd',
    'sources.delete_confirm': 'Deze bron verwijderen?',
    'sources.scan_running': 'Scannen...',
    'sources.scan_done': 'Scan voltooid',
    'sources.scan_error': 'Scanfout',

    'social.title': 'Sociale Radar',
    'social.no_posts': 'Geen sociale berichten gevonden.',
    'social.launch_scan': 'Start een scan om berichten van actieve bronnen op te halen.',
    'social.view_post': 'Bekijk post',

    'discovery.title': 'Ontdekking',
    'discovery.events_discovered': 'Ontdekte evenementen',
    'discovery.scan_logs': 'Scanlogs',
    'discovery.refresh': 'Vernieuwen',
    'discovery.events_label': 'Evenementen',
    'discovery.scans_ok': 'Scans OK',
    'discovery.errors': 'Fouten',
    'discovery.detected_by_scan': 'Gedetecteerd door scan',
    'discovery.no_events': 'Geen evenementen ontdekt.',
    'discovery.no_scans': 'Geen scans uitgevoerd.',

    'validation.title': 'Validatiewachtrij',
    'validation.validate_all': 'Alles valideren',
    'validation.no_pending': 'Geen evenementen in afwachting van validatie.',
    'validation.suspected_dupes': 'Vermoedelijke duplicaten',
    'validation.similarity': 'gelijkenis',
    'validation.validate': 'Valideren',
    'validation.reject': 'Afwijzen',
    'validation.edit': 'Bewerken',
    'validation.artists': 'Artiesten',
    'validation.venue_known': 'Bekende locatie',
    'validation.venue_unknown': 'Onbekende locatie',
    'validation.keep_first': 'Bewaar 1e, wijs 2e af',
    'validation.keep_second': 'Bewaar 2e, wijs 1e af',
    'validation.ignore': 'Negeren',
    'validation.pairs': '{n} pa(a)r(en) — zelfde datum, zelfde stad, vergelijkbare titels',
    'validation.flyer_matches': 'Flyer-overeenkomsten (pHash)',
    'validation.merge_keep_left': 'Samenvoegen (bewaar 1e)',
    'validation.merge_keep_right': 'Samenvoegen (bewaar 2e)',
    'validation.close': 'Sluiten',
    'validation.not_duplicate': 'Geen duplicaat',
    'validation.expand': 'Uitklappen',
    'validation.collapse': 'Inklappen',
    'validation.view_source': 'Bron',
    'validation.view_pending': 'In afwachting',
    'validation.view_rejected': 'Afgewezen',
    'validation.rejected_title': 'Afgewezen events',
    'validation.rejected_hint': 'Analyseer redenen om systematische bugs op te sporen',
    'validation.no_rejected': 'Geen afgewezen events',
    'validation.permanent_delete': 'Definitief verwijderen',
    'validation.confirm_permanent_delete': 'Dit event definitief verwijderen? Dit kan niet ongedaan worden gemaakt.',

    'artists.title': 'Artiesten & Sound Systems',
    'artists.search': 'Zoek artiest of sound system...',
    'artists.artists': 'artiesten',
    'artists.sound_systems': 'sound systems',
    'artists.genres': 'Genres',
    'artists.country': 'Land',
    'artists.links': 'Links',
    'artists.artist': 'Artiest',
    'artists.next_event_in': 'Volgend event over',
    'artists.events_count': 'Evenementen',
    'artists.no_events': 'Geen gekoppelde evenementen',

    'soundsystems.title': 'Sound Systems',
    'soundsystems.followed': 'gevolgde sound systems',
    'soundsystems.search': 'Zoek sound system...',
    'soundsystems.no_found': 'Geen sound systems gevonden.',
    'soundsystems.events_count': 'Evenementen',
    'soundsystems.no_events': 'Geen evenementen gedetecteerd',
    'soundsystems.website': 'Website',

    'sidebar.this_week': 'Deze Week',
    'sidebar.no_events': 'Geen events deze week',
    'sidebar.by_city': 'Per Stad',
    'sidebar.all_cities': 'Alle',
    'sidebar.view_on_map': 'Bekijk {n} op kaart',
    'sidebar.by_month': 'Per Maand',
    'sidebar.active_sources': 'Actieve Bronnen',
    'sidebar.venues': 'locaties',

    'add_event.title': 'Evenement Toevoegen',
    'add_event.event_name': 'Naam evenement',
    'add_event.title_label': 'Titel',
    'add_event.date_label': 'Datum',
    'add_event.price_label': 'Prijs',
    'add_event.price_placeholder': '10€ / Gratis',
    'add_event.venue_label': 'Locatie',
    'add_event.venue_placeholder': 'Naam locatie',
    'add_event.city_label': 'Stad',
    'add_event.city_placeholder': 'Brussel',
    'add_event.genres_label': 'Genres',
    'add_event.description_label': 'Beschrijving',
    'add_event.description_placeholder': 'Beschrijving evenement',
    'add_event.source_label': 'Bronlink',
    'add_event.create': 'Evenement aanmaken',
    'add_event.saving': 'Opslaan...',

    'flyer.scanner': 'FLYER SCANNER',
    'flyer.powered': 'VISION AI POWERED',
    'flyer.instructions': 'Maak een foto van een poster, upload een flyer, of plak vanuit klembord (Ctrl+V)',
    'flyer.drop_here': 'Sleep een flyer hierheen',
    'flyer.click_upload': 'of klik om een bestand te kiezen',
    'flyer.paste': 'Ctrl+V om te plakken vanuit klembord',
    'flyer.upload': 'Upload...',
    'flyer.prescan': 'Voorscan...',
    'flyer.vision': 'Vision AI...',
    'flyer.finalizing': 'Afronden...',
    'flyer.minimize': 'Minimaliseren',
    'flyer.validate': 'Valideren',
    'flyer.saving': 'Opslaan...',
    'flyer.start': 'Begin',
    'flyer.end': 'Einde',
    'flyer.artists': 'Artiesten',
    'flyer.missing_date': 'Datum verplicht — OCR vond die niet op de flyer. Vul ze in om op te slaan.',
    'flyer.missing_title': 'Titel verplicht. Vul die in om op te slaan.',
    'flyer.missing_title_date': 'Titel en datum verplicht — OCR vond ze niet op de flyer.',
    'flyer.session_expired': 'Sessie verlopen — log opnieuw in en probeer opnieuw.',
    'flyer.save_failed': 'Opslaan mislukt. Probeer opnieuw.',

    'ocr.label': 'OCR',
    'ocr.tesseract': 'Alleen Tesseract',
    'ocr.vision_light': 'Vision Light',
    'ocr.vision_medium': 'Vision Medium',
    'ocr.vision_full': 'Vision Full',

    'ig.missing': 'Instagram sessie ontbreekt — Instagram accounts kunnen niet worden gescraped.',
    'ig.expired': 'Instagram sessie verlopen.',
    'ig.invalid': 'Instagram sessie ongeldig.',
    'ig.logging_in': 'Een Chrome venster is geopend — log in bij Instagram.',
    'ig.waiting': 'Wachten op verbinding…',
    'ig.reconnect': 'Instagram herverbinden',

    // ── Support ──
    'support.button': 'Steun de Riddim Radar',
    'support.button_short': 'Support Riddim Radar',
    'support.title': 'Hoe de Riddim Radar te steunen',
    'support.intro': 'Bedankt dat je ons wilt steunen en we zijn dankbaar dat je de Riddim Radar leuk vindt. Deze tool is gratis en ontworpen met AI-code als een geschenk aan de reggae- en dubgemeenschap.',
    'support.sources_message': 'Het berust op het onvermoeibare werk van onze bronnen en is slechts een aggregator van het werk van echte mensen die evenementen organiseren, flyers ontwerpen, sound systems bouwen, collectieven runnen en social media accounts wijden aan het verspreiden van evenementen en de Jah vibe.',
    'support.action_intro': 'Hier is een lijst van de bronnen die we aggregeren op Riddim Radar. Ga naar hun sociale netwerken en volg ze om hun publiek te vergroten. Geef ze likes en deel de evenementen en de verhalen. Volg de artiesten en koop hun muziek.',
    'support.action_flyer': 'Ga naar je favoriete bar en organiseer een gratis dubavond (vergeet niet de flyer te uploaden naar de flyer OCR zodat we het hier kunnen vermelden).',
    'support.future': 'We hebben wat ideeeen voor de toekomst waar we misschien om donaties vragen voor specifieke projecten, maar voorlopig is de beste manier om ons te steunen het steunen van onze bronnen. Deze tool is slechts een manier om hen te bedanken voor hun ongelooflijke liefde en toewijding.',
    'support.thanks': 'Dank je',
    'support.bless': 'Jah bless',
    'support.contact': 'Als je contact met ons wilt opnemen:',
    'footer.tagline': 'persoonlijk, niet-commercieel project',
    'footer.legal': 'Juridische informatie',
    'footer.privacy': 'Privacybeleid',
    'footer.contact': 'Contact',
    'support.our_sources': 'Onze bronnen',
    'support.artists_link': 'Bekijk artiesten',
    'support.follow': 'Volgen',

    'date.days': 'zondag,maandag,dinsdag,woensdag,donderdag,vrijdag,zaterdag',
    'date.months': 'januari,februari,maart,april,mei,juni,juli,augustus,september,oktober,november,december',
    'date.months_short': 'jan.,feb.,mrt,apr.,mei,juni,juli,aug.,sep.,okt.,nov.,dec.',
  },
};
